import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import FlashMessage from '@smartweb/vue-flash-message'
import auth from './modules/authentication/auth'

// Modules
import './modules/authentication'
import './modules/command'
import './modules/api_token'

auth.getAuthenticatedUser()
	.catch(e => void e)
	.finally(() => {
		createApp(App)
			.use(router)
			.use(FlashMessage)
			.mount('#app');
	})
;
